module.exports = __webpack_public_path__ + "img/public/SiteIcons/incrementPlus.svg?e82b0145";